import { HeaderMenu } from "components";
import { HeaderSection } from "./HeaderSection";
import { TableSection } from "./TableSection";
import { AdjustmentInventoryType, useDataCode } from "../utils";
import { useFormContext, useWatch } from "react-hook-form";
import { Fragment, useEffect } from "react";

export function FormDirectAdjusment(props: {
  title: string,
  isEdit?: boolean
  refetch?: () => void
}) {
  return (
    <>
      <HeaderMenu title={props.title}>
        <Code />
      </HeaderMenu>

      <HeaderSection isEdit={props.isEdit} />

      <TableSection isEdit={props.isEdit}/>
    </>
  )
}


function Code(): JSX.Element {
  // Hooks
  const { fetchCode } = useDataCode()

  // Form
  const { control, formState, setValue } = useFormContext<AdjustmentInventoryType>()
  const transaction_date = useWatch({
    control,
    name: "transaction_date"
  })
  const trx_code = useWatch({
    control,
    name: "trx_code"
  })


  useEffect(() => {
    if (!formState.defaultValues?.trx_code) {
      fetchCode(transaction_date).then(res => {
        setValue("trx_code", res)
      }).catch(err => {
        setValue("trx_code", err)
      })
    }

    // eslint-disable-next-line
  }, [transaction_date, trx_code])

  return <Fragment>{trx_code}</Fragment>
}